import { SearchBar } from '@amelio/ui-library';

import { TOOLBAR_CONTROL_SURFACE } from '@/components/objectives/objectiveStyles';
import { useDebouncedCommit } from '@/hooks/utils/useDebouncedCommit';
import { TOOLBAR_CONTROL_TEXT_SIZE } from '@/utils/toolbarStyles';

interface ObjectiveSearchFieldProps {
    /** The name the list is searched by, as the address holds it. */
    value: string;
    onChange: (text: string) => void;
    placeholder: string;
    dataTestId: string;
}

/**
 * The name searched on a list of the objectives module, the same field on each: shown as typed,
 * handed on once the reader pauses, so the address is written once per pause rather than per key.
 */
export default function ObjectiveSearchField({
    value,
    onChange,
    placeholder,
    dataTestId,
}: ObjectiveSearchFieldProps) {
    const [typed, setTyped] = useDebouncedCommit(value, onChange);

    return (
        <div className={'obj-toolbar-control'}>
            {/* `md` is the library's 40px step, shared by the attribute filter and the cycle
                select beside it, which wear the same glass surface. */}
            <SearchBar
                value={typed}
                onChange={setTyped}
                placeholder={placeholder}
                size={'md'}
                textSize={TOOLBAR_CONTROL_TEXT_SIZE}
                showClearButton={false}
                className={TOOLBAR_CONTROL_SURFACE}
                dataTestId={dataTestId}
            />
        </div>
    );
}
